enum BadgeSize {
    XS = '8px',
    SMALL = '12px',
    MEDIUM = '16px',
    LARGE = '20px',
}

export default BadgeSize;